import React from 'react';

function ErrorOutline() {
  return (
    <svg width="77" height="76" viewBox="0 0 77 76" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M34.6319 49.25H42.2014V56.75H34.6319V49.25ZM34.6319 19.25H42.2014V41.75H34.6319V19.25ZM38.3788 0.5C17.4871 0.5 0.569427 17.3 0.569427 38C0.569427 58.7 17.4871 75.5 38.3788 75.5C59.3083 75.5 76.2639 58.7 76.2639 38C76.2639 17.3 59.3083 0.5 38.3788 0.5ZM38.4167 68C21.6882 68 8.13887 54.575 8.13887 38C8.13887 21.425 21.6882 8 38.4167 8C55.1451 8 68.6944 21.425 68.6944 38C68.6944 54.575 55.1451 68 38.4167 68Z"
        fill="#FB0078"
      />
    </svg>
  );
}

export default ErrorOutline;
